import {
  build,
  buildWithShareParams,
  canIUse,
  getPageConfig,
  hashQuery,
  initSDK,
  initV2,
  PerfTrack,
  query,
  setLoginConfig,
  setOmegaAttrs,
  trackEvent,
  // eslint-disable-next-line prettier/prettier
  xenv,
} from '@didi/webx-js'
import mpx from '@mpxjs/core'
import { PRE_INIT_LIST } from '../constants'
import { getCommonData } from '../service'
import store from '../store'
import {
  defaultAliLink,
  formatPageConfig,
  getQuery,
  initLocation,
  initLogin,
  isSSG,
  setShare,
  setShareForWebx,
  setTitle,
  // eslint-disable-next-line
  shareConfig,
} from '../utils'

export default function (branch = 'passenger') {
  return {
    onShareAppMessage() {
      if (this.info.needShareConfig) {
        return this.miniShareInfo || Promise.reject()
      }
      const { title, webxPath, shareCardImage } =
        shareConfig[this.info.template]
      const shareConf = {
        title: title,
        path: build(buildWithShareParams(webxPath), getQuery()),
        imageUrl: shareCardImage,
      }
      if (__mpx_mode__ === 'ali') {
        shareConf.bgImgUrl = shareCardImage
      }
      return {
        title: title,
        path: build(buildWithShareParams(webxPath), getQuery()),
        imageUrl: shareCardImage,
      }
    },
    data: {
      pageConfig: null,
      info: {},
      show: false,
      loading: true,
      hasError: false,
      pageErrorMessage: '服务异常，请稍后再试',
      miniShareInfo: null,
      exception: {},
    },
    computed: {
      ...store.mapGetters(['query', 'initData', 'productType', 'PerfTrack']),
      disableShare() {
        /** 临时hack：网约车模版端内禁用分享。待梳理拉端分享链路后优化 @tianjingsi 2023-04-27 */
        console.log('======================this.initData:', this.initData)
        if (
          xenv() === 'passenger' &&
          this.initData.activity_info.is_for_app_download
        ) {
          return true
        }
        /** hack 结束 */

        return this.query.exchange_pwd && this.query.pwd_type === 'coupon'
      },
    },
    async onLoad(options) {
      initSDK({ branch })
      const queryInfo =
        __mpx_mode__ === 'ali' ? options : { ...query(), ...hashQuery() }
      store.commit('reset') // 防止第二次打开被缓存
      store.commit('setQuery', queryInfo)
      // 本地mock数据在utils.js中
      if (isSSG()) {
        this.pageConfig =
          window.__INITIAL_STATE__.xpubData.scenes.layers[0].props.pageConfig
      }
      this.info = this.props.info.value()
      let entryOptions = {}
      if (__mpx_mode__ === 'wx') {
        entryOptions = wx.getEnterOptionsSync()
      }
      this.setPerfTrack(
        PerfTrack.init({
          dchn: this.query.dchn,
          prod_key: this.info.prodKey || 'ut-dunion',
          extra: {
            api_category: entryOptions?.apiCategory || '',
            entry_options: entryOptions,
          },
        })
      )
      this.PerfTrack.jsReady()
      this.setLoginConfig()
      const omegaAttrs = {
        ...this.info,
        xenv: this.query.xenv,
        promotion_type: this.query.exchange_pwd ? 2 : 1,
      }
      setOmegaAttrs(omegaAttrs)
      initLogin()
      if (__mpx_mode__ !== 'web') {
        // 口令码禁止分享，下方在 onUnload 中打开
        this.disableShare && mpx.hideShareMenu()
        this.locate()
      } else if (xenv() === 'passenger') {
        await this.locate()
      } else {
        this.locate()
      }
      await Promise.all([
        this.init(),
        this.getPageConfig().catch(e => {
          console.log(e)
        }),
      ])
      if (!this.pageConfig) {
        console.log('pageConfig兜底')
        this.pageConfig = this.props.pageConfig.value()
        this.hasError = true
      }
    },
    onUnload() {
      if (__mpx_mode__ !== 'web') {
        this.disableShare && mpx.showShareMenu()
      }
    },
    watch: {
      pageConfig(val) {
        const hasValue = val && Object.keys(val).length
        // 排除pageConfig和initV2都存在值，但pageConfig先返回的情况
        const validPageConfig = isSSG() || Object.keys(this.initData).length
        if (!hasValue || !validPageConfig) {
          this.closeLoading()
          return
        }
        formatPageConfig(this.pageConfig, this.info.template)
        this.show = true
        this.closeLoading()
        setTitle(this.pageConfig.index?.title)
        if (__mpx_mode__ === 'web') {
          !this.disableShare && setShare(this.info)
        }
      },
    },
    methods: {
      ...store.mapMutations(['setInitData', 'setPerfTrack']),
      async locate() {
        await initLocation(
          this.info.template !== 'cz' &&
            this.info.template !== 'ny' &&
            this.info.template !== 'hxz'
        ).catch(e => {
          console.log(e)
        })
      },
      async init() {
        this.PerfTrack.requestBegin()
        try {
          const args = getCommonData()
          args.cz_upgrade = 1 // 滴滴联盟车主改版，新老活动兼容标识，上线全量之后可以删除
          const hasLocate = !!(args.lng || args.lat || args.cityId) // 网约车签到后续调用应该和本次一致
          const res = await initV2({
            initOption: {
              needPageConfig: true,
              needShareConfig: !!this.info.needShareConfig,
              config: {
                need_project_content: !isSSG(),
                dchn: this.query.dchn,
                args,
              },
            },
          })
          this.pageErrorMessage =
            res.conf.strategy_data.data?.group?.status_desc
          // if (res.conf.strategy_data.errno !== 0) {
          //   mpx.showToast({
          //     icon: 'none',
          //     mask: true,
          //     title: res.conf.strategy_data.errmsg,
          //   })
          // }
          this.setInitData(
            Object.assign({ hasLocate }, res.conf.strategy_data.data)
          )

          // 活动返回异常，直接return掉
          if (res?.conf?.strategy_data?.data?.group?.status !== 1) {
            this.exception =
              res?.conf?.content_conf?.exception_data?.scenes?.layers?.[0]
                ?.props?.errorPageConf || {}
            return
          }

          const pageConfig =
            res.conf.content_conf?.project_data?.scenes?.layers?.[0]?.props
              ?.pageConfig
          if (pageConfig) {
            this.pageConfig = pageConfig
          } else {
            // 触发watch
            this.pageConfig && (this.pageConfig = { ...this.pageConfig })
            trackEvent('tech_ut_dunion_fe', '', {
              name: '老活动活动内容',
            })
          }
          // open_share：如果赤兔关闭分享开关，则不展示分享按钮 0-关闭 1-打开
          if (
            this.info.needShareConfig &&
            !this.disableShare &&
            res.shareConf?.open_share !== 0
          ) {
            this.miniShareInfo = setShareForWebx(res.shareConf, this.info)
          }

          // 兼容网约车、花小猪老活动没有配置支付宝跳转地址
          if (
            ['wyc', 'hxz'].includes(this.info.template) &&
            !this.pageConfig.index.alipay_link
          ) {
            this.pageConfig.index.alipay_link =
              defaultAliLink[this.info.template] || ''
            if (
              this.info.template === 'wyc' &&
              !this.pageConfig.signVersion.index.alipay_link
            ) {
              this.pageConfig.signVersion.index.alipay_link = defaultAliLink.wyc
            }
          }

          // 渠道礼包关闭分享开关后隐藏小程序的分享按钮
          if (
            __mpx_mode__ === 'wx' &&
            this.info.template === 'gift' &&
            res.shareConf?.open_share === 0
          ) {
            mpx.hideShareMenu({
              menus: ['shareAppMessage', 'shareTimeline'],
            })
          }

          setOmegaAttrs({
            coupon_type: this.initData.activity_info?.is_auto_receive
              ? 'auto'
              : 'hand',
            xak: this.initData.activity_info?.x_act_key,
            xid: res.conf.xid,
          })
        } catch (e) {
          this.pageErrorMessage =
            e?.data?.conf?.strategy_data?.data?.group?.status_desc
          // mpx.showToast({
          //   icon: 'none',
          //   title: this.pageErrorMessage || '服务异常，请稍后再试',
          //   duration: 2000,
          //   mask: true,
          // })
          this.exception =
            e?.data?.conf?.content_conf?.exception_data?.scenes?.layers?.[0]
              ?.props?.errorPageConf || {}

          console.error(e)
        }
        PerfTrack.responseReady()
      },
      async getPageConfig() {
        // 老活动的活动内容，并不在APS的initV2中,需要通过getPageConfig获取
        if (isSSG()) {
          return
        }
        const resPageConfig = await getPageConfig({
          args: {
            dchn: this.query.dchn,
          },
        })
        if (!this.pageConfig) {
          this.pageConfig =
            resPageConfig.conf.ext.content_conf.project_data.scenes.layers[0].props.pageConfig
        }
      },
      setLoginConfig() {
        store.commit('setProductType', this.info.productType || 'didi')
        const loginConfig = {
          extra_info: {
            dchn: this.query.dchn,
            entrance_channel: this.query.entrance_channel,
            channel: this.query.channel,
          },
        }
        if (__mpx_mode__ === 'web') {
          if (
            xenv() === 'weixin' &&
            this.query.code &&
            window.sessionStorage.getItem('wxOauth') === this.query.state
          ) {
            loginConfig.useOauthCode = this.info.wxOauth
            loginConfig.unionidLogin = this.info.wxOauth
            loginConfig.oauthcode = this.query.code
          }
        }
        if (__mpx_mode__ === 'web') {
          if (this.info.wxOauth) {
            const appid = {
              kf: 130018, // 线下 121357
              didi: 121230,
            }
            loginConfig.appid = appid[this.productType || 'didi']
          } else if (xenv() === 'gaswxmp') {
            loginConfig.appid = 121061
          }
        }
        canIUse('setLoginConfig') && setLoginConfig(loginConfig)
        const query = { ...this.query }
        delete query.xenv // 拉端会拼接xenv是空，导致会把默认sdk的xenv覆盖成空
        setOmegaAttrs(query)
      },
      closeLoading() {
        if (__mpx_mode__ === 'web') {
          const loading = document.querySelector('#loading')
          loading && (loading.style.display = 'none')
          this.$nextTick(() => {
            this.PerfTrack.domReady({
              isKey: true,
            })
          })
        } else {
          this.$nextTick(() => {
            this.loading = false
            this.PerfTrack.domReady({
              isKey: true,
            })
            if (
              // eslint-disable-next-line @didi/fin-check/usage-mpx-mode
              __mpx_mode__ === 'wx' &&
              PRE_INIT_LIST.includes(query().prod_key)
            ) {
              mpx.performance.timeEnd('webx_links_perf', {
                info: `${query().prod_key}|${query().dchn}`,
              })
            }
          })
        }
      },
    },
  }
}
